import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useSearchCallOutcomeMutation } from '../../../services'
import { UspConfigurationCallOutcomeViewResult, UspConfigurationSmsTemplateViewResult } from '../../../models'
import Header from '../components/Header/Header'
import SmsTemplatesTable from './components/SmsTemplatesTable'
import AddEditSmsTemplates from './components/AddEditSmsTemplates'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'
import { useSearchTemplateMutation } from '../../../services/Templates/TemplateApi'

const CommunicationsSmsTemplates = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchTemplate, { data, isLoading }] = useSearchTemplateMutation()
  const [smsTemplateData, setSmsTemplate] = useState<UspConfigurationSmsTemplateViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchTemplate({
      data: {
        dataSource: null,
        isIncludeInactive: values.isIncludeInactive,
        searchString: values.searhString,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setSmsTemplate(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Sms Templates'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <SmsTemplatesTable
                      submit={submit}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={smsTemplateData}
                      setData={setSmsTemplate}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditSmsTemplates
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCallOutcomeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default CommunicationsSmsTemplates
